/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S6_HeadingInputs */

const tr_kullanim_s6_heading = /** @type {(inputs: Kullanim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Mali Hükümler`)
};

const en_kullanim_s6_heading = /** @type {(inputs: Kullanim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Financial provisions`)
};

const de_kullanim_s6_heading = /** @type {(inputs: Kullanim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Finanzielle Bestimmungen`)
};

const ru_kullanim_s6_heading = /** @type {(inputs: Kullanim_S6_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Финансовые положения`)
};

/**
* | output |
* | --- |
* | "6. Financial provisions" |
*
* @param {Kullanim_S6_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s6_heading = /** @type {((inputs?: Kullanim_S6_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S6_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s6_heading(inputs)
	if (locale === "de") return de_kullanim_s6_heading(inputs)
	if (locale === "ru") return ru_kullanim_s6_heading(inputs)
	return tr_kullanim_s6_heading(inputs)
});